module.exports = __webpack_public_path__ + "img/03_maska_krug_2.5205979.svg";